//
import { mapActions, mapState } from 'vuex'
import {
    ModelDataTable,
    RForm,
    VBtnAction,
} from '@/components/reusable_components/next'

//
import PurchaseOrderService from '@/services/api/Purchase/PchPurchaseOrder'
import Translator from '@/services/translator'
import filters from './filters'
import headers from './headers'

//
import { RequiredRule } from '@/mixins/reusable_mixins/rules'

//
export default {
    name: 'purchase-order-list',
    components: {
        VBtnAction,
        'crud-data-table': ModelDataTable,
        RForm,
    },
    computed: {
        /**
         * 
         */
        removeProps() {
            return {
                fields: [
                    {
                        name: 'reject_provider_comment',
                        type: 'textarea',
                        flex: {
                            xs12: true,
                        },
                        props: {
                            label: 'Comentario',
                            rules: [RequiredRule],
                        },
                    }
                ]
            }
        },
        /**
         *
         */
        tableProps() {
            return {
                ...this.tableParams,
                service: new PurchaseOrderService().toList(),
                filters,
                headers,
                rowsPerPage: 25,
            }
        },
    },
    data() {
        return {
            dialogs: {
                remove: false,
            },
            removeData: {

            },
            selected: null,
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setItemsTopBar: 'setItemsTopBar',
            setTitleTopBar: 'setTitleTopBar',
        }),
        applyRemove() {
            return this
                .toWaitRemove(true)
                .then(this.remove)
                .then(() => this.toWaitRemove(false))
        },

        /**
         * @description
         *
         */
        create() {
            this.$router.push({ name: 'purchase-order-create' })
        },

        /**
         *
         */
        errorRemove(error) {
            this.showErrorSnackbar(Translator(PurchaseOrderService, error.response.data))
        },

        /**
         *
         */
        remove(data) {
            return this
                .selected
                .remove(data)
                .then(this.successRemove)
                .then(this.$refs.table.refresh)
                .catch(this.errorRemove)
        },

        /**
         *
         */
        showPdf(res) {
            var fileURL = URL.createObjectURL(res.data)
            window.open(fileURL)
        },

        /**
         *
         */
        submitPdf(event) {
            event.item.pdf().then(this.showPdf)
        },

        /**
         *
         */
        submitRemove(event) {
            this.removeData = {}
            this.selected = event.item
            this.dialogs.remove = true
        },

        /**
         *
         */
        submitUpdate(event) {
            this.$router.push({
                name: 'purchase-order-update',
                params: { id: event.item.id },
            })
        },

        /**
         *
         */
        successRemove() {
            this.showSuccessSnackbar('Orden de compra eliminada exitosamente.')
            this.dialogs.remove = false
        },
        toWaitRemove(value = false) {
            return this
                .$refs
                .remove
                .setWait(value)
        },
    },
    props: {
        /**
         *
         */
        noItems: Boolean,
        noRemove: Boolean,

        /**
         *
         */
        noTitle: Boolean,

        /**
         *
         */
        tableParams: {
            type: Object,
            default: () => ({}),
        },
    },    
    watch: {

        /**
         *
         */
        responseConfirmSnackbar(val) {
            switch (val) {
                case 'eliminar':
                    return this.remove()
            }
        },
    },
    watch: {

        /**
         *
         */
        responseConfirmSnackbar(val) {
            switch (val) {
                case 'eliminar':
                    return this.remove()
            }
        },
    },
    mounted() {
        // set the view title
        if(!this.noTitle) {
            this.setTitleTopBar('Ordenes de compra')
        }

        // set the view top bar items
        if (!this.noItems) {
            this.setItemsTopBar([
                {
                    action: this.create,
                    color: 'accent',
                    icon: 'add_circle',
                    text: 'crear orden de compra',
                    tip: 'Crear nueva orden de compra',
                },
            ])
        }
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_PURCHASE_ORDER')) ctx.$router.push('/')
        })
    },
}
